/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    brokerHelp: {
        id: 'agent.views.policy-landing.Broker Help',
        defaultMessage: 'Contact Broker Help when:',
    },
    unableToLogin: {
        id: 'agent.views.policy-landing.Unable to login',
        defaultMessage: 'Unable to login',
    },
    bluepassNotWorking: {
        id: 'agent.views.policy-landing.BluePass isnt working',
        defaultMessage: "BluePass isn't working",
    },
    frozenScreen: {
        id: 'agent.views.policy-landing.Frozen screen',
        defaultMessage: 'Frozen screen',
    },
    eDocs: {
        id: 'agent.views.policy-landing.Missing eDocs or downloads',
        defaultMessage: 'Missing eDocs or downloads',
    },
    brokerHelpTollFreeNumber: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.BrokerHelpTollFreeNumber',
        defaultMessage: 'Broker Help Toll Free Number: &lt;strong&gt;1-(877) 985-3976&lt;/strong&gt;',
    },
    brokerEmail: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.Broker Help Email',
        defaultMessage: 'Email: ',
    },
    brokerEmailAddress: {
        id: 'agent.views.policy-landing.Broker Help Email Address',
        defaultMessage: 'brokerhelp@wawanesa.com',
    },
    billingInquiryFor: {
        id: 'agent.views.policy-landing.Billing Inquiry',
        defaultMessage: 'Contact Billing Inquiry for:',
    },
    refundInquiries: {
        id: 'agent.views.policy-landing.Billing/Payment/Refund inquiries',
        defaultMessage: 'Billing/Payment/Refund inquiries',
    },
    creditCardIssues: {
        id: 'agent.views.policy-landing.Credit card issues',
        defaultMessage: 'Credit card issues',
    },
    assistanceWithdrawalDateChange: {
        id: 'agent.views.policy-landing.Assistance with processing a withdrawal date change',
        defaultMessage: 'Assistance with processing a withdrawal date change',
    },
    assistanceUpdatingInfo: {
        id: 'agent.views.policy-landing.Assistance with updating bank information',
        defaultMessage: 'Assistance with updating bank information',
    },
    billingInquiryTollFreeNumber: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.BillingInquiryTollFreeNumber',
        defaultMessage: 'Billing Inquiry Toll Free Number: &lt;strong&gt;1-(833) 663-9292&lt;/strong&gt;',
    },
    contactUnderwriter: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.Underwriter Help',
        defaultMessage: 'Contact an Underwriter for:',
    },
    underwritingMessage: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.UnderwritingMessage',
        defaultMessage: 'Underwriting message received resulting in an error or blocked transaction',
    },
    assistanceTransaction: {
        id: 'agent.views.policy-landing.Assistance completing a transaction',
        defaultMessage: 'Assistance completing a transaction',
    },
    coverageQuestions: {
        id: 'agent.views.policy-landing.Coverage questions',
        defaultMessage: 'Coverage questions',
    },
    premiumReview: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.PremiumReview',
        defaultMessage: 'Premium review',
    },
    personalLinesTollFreeNumber: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.PersonalLinesTollFreeNumber',
        defaultMessage: 'Personal Lines Toll Free Number: &lt;strong&gt;1-(888) 985-3951&lt;/strong&gt;',
    },
    commercialLinesTollFreeNumber: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.CommercialLinesTollFreeNumber',
        defaultMessage: 'Commercial Lines Toll Free Number: &lt;strong&gt;1-(844) 929-2633&lt;/strong&gt;',
    },
    forMoreInfo: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.Visit Broker Platform',
        defaultMessage: 'For more information, please visit ',
    },
    portalLink: {
        id: 'agent.views.policy-landing.Visit Broker Platform Link',
        defaultMessage: 'https://login.brokerplatform.wawanesa.com',
    },
    portalLinkText: {
        id: 'wmic-pe-capability-gateway-react.Components.WMICPageHeader.openHelpModalPopup.openHelpModalPopup.Visit Broker Platform Link Text',
        defaultMessage: 'Broker Platform',
    },
});
